import React from "react";
import * as Icons from "lucide-react";
import { MessageCircle, Mail } from "lucide-react";
import { capabilities, contact } from "../mock";

export default function ShipmentCapabilities() {
  return (
    <section className="py-16 lg:py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-10 lg:gap-14 items-start">
        <div>
          <p className="inline-block text-teal-600 font-bold uppercase tracking-widest text-xs bg-teal-100/60 px-4 py-1.5 rounded-full mb-4">Shipment Capabilities</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight mb-5">What Medicines We Can Courier Internationally</h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            ShipMeds is the best medicine courier company in India. We ship a wide range of medicines to meet your healthcare needs — from liquid and allopathic medicines to ayurvedic and homeopathic medicines from leading manufacturers.
          </p>
          <p className="text-slate-600 leading-relaxed mb-4">
            We cater to medications for various conditions including chronic diseases — cancer, diabetes, HIV, hepatitis, arthritis, tuberculosis, respiratory and liver diseases, hypertension and heart conditions — as well as common ailments.
          </p>
          <p className="text-slate-600 leading-relaxed mb-6">
            If you have questions or need guidance on specific medications, feel free to contact our medicine expert team. We’re here to ensure you get the right medicine couriered to your doorstep.
          </p>
          <div className="flex flex-wrap gap-3">
            <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-3 rounded-lg transition-colors">
              <MessageCircle className="w-4 h-4" /> Call / WhatsApp Support
            </a>
            <a href={`mailto:${contact.email}`} className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:border-teal-400 text-slate-700 font-semibold px-5 py-3 rounded-lg transition-colors">
              <Mail className="w-4 h-4" /> E-Mail Inquiry
            </a>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          {capabilities.map((c) => {
            const Icon = Icons[c.icon] || Icons.Pill;
            return (
              <div key={c.title} className="group bg-white rounded-2xl overflow-hidden border border-slate-100 card-shadow hover:-translate-y-1 transition-transform">
                <div className="relative h-40 overflow-hidden">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 right-3 w-9 h-9 rounded-lg bg-white/90 backdrop-blur flex items-center justify-center text-teal-600">
                    <Icon className="w-5 h-5" />
                  </div>
                </div>
                <div className="p-5">
                  <h4 className="font-bold text-slate-900 mb-1.5">{c.title}</h4>
                  <p className="text-sm text-slate-500 leading-relaxed">{c.desc}</p>
                </div>
                <div className="h-1 bg-gradient-to-r from-teal-500 to-blue-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
